<script>
import GuestService from '../services/guest-service'

export default {
    methods: {
        checkInviteCode(callback = null) {
            const GUEST_CODE = this.$route.query.code

            GuestService.verifyCode(GUEST_CODE).then(response => {
                if (!response.data.code) {
                    this.notifyError('we can`t verify your invitation code')
                    return false
                }
                // remove code with  building amenity
                let code = response.data
                
                if (GUEST_CODE !== code.code || response.data.amenity!=undefined) {
                    this.notifyError('we can`t verify your invitation code')
                    return false
                }

                let consent = code.building.consent,
                    rules = code.building.rules
                if ( (consent.required && !consent.set) || (rules.required && !rules.set) ){
                    this.notifyError('current building needs to finish setup of it`s rules and consent')
                    return false
                }

                if (!this.$store.state.registration.guest.code) {
                    this.code = code
                    this.$store.commit('registration/setGuestCode', code)
                } else {
                    this.code = this.$store.state.registration.guest.code
                }

                if (callback){
                    callback(code);
                }

            }).catch(() => {
                this.notifyError('we can`t verify your invitation code')
            })
        },

        notifyError(string) {
            let that = this
            this.$notify.error({
                title: 'Error',
                message: 'We are sorry but ' + string,
                duration: 0,
                onClose: function(){
                    that.$router.push('/')
                }
            });
        }
    }
}
</script>